import script from "./FreeTrialEndAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./FreeTrialEndAlert.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__